
            const data = {"name":"play","data":{"width":"15","height":"16","viewBox":"0 0 15 16","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.503.39a1 1 0 0 0-1.519.856v13.446a1 1 0 0 0 1.52.854L13.577 8.81a1 1 0 0 0-.001-1.71L2.503.39Z\" _fill=\"#000\"/>","originalColors":[{"type":"fill","color":"#000"}],"stopColors":[]}}
        
                module.exports = data
                